import { createRoot } from "react-dom/client";
import { BookingWizard } from "../../islands/booking/BookingWizard.js";

const el = document.querySelector<HTMLElement>('[data-island="booking-wizard"]');
if (el) {
  createRoot(el).render(<BookingWizard />);
}
